import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Spin } from '@arco-design/web-react';

import { usePlatformConfig } from '@/hooks';
import { resolveLoginPageEntryAction, resolveLoginRedirectPath } from '@/service/auth-recovery';
import { getAccessToken, getRefeshToken } from '@/utils/useLocalStorage';

import Login from './components';
import styles from './index.module.less';

function LoginPage() {
  const { t } = useTranslation();
  const { platformConfig } = usePlatformConfig();
  const defaultRecordNumber = t('login-page:brand.default.record.number');
  const entryAction = resolveLoginPageEntryAction(getAccessToken(), getRefeshToken());

  useEffect(() => {
    if (entryAction !== 'redirect') return;
    window.location.replace(resolveLoginRedirectPath(window.location.search));
  }, [entryAction]);

  if (entryAction === 'redirect') {
    return <Spin block size={40} style={{ display: 'flex', marginTop: '200px', justifyContent: 'center' }} />;
  }

  return (
    <div style={{ display: 'flex' }}>
      <div className={styles.loginBg}>
        <section className={styles.brandCopy}>
          <h1>{platformConfig.systemName}</h1>
          <h2>{t('login-page:brand.subtitle')}</h2>
          <p>{t('login-page:brand.description')}</p>
        </section>
      </div>
      <div className={styles.wrapper}>
        <Login logoURL={platformConfig.logoURL} />
      </div>
      <div className={styles.recordNumber}>
        {platformConfig.recordNumber === defaultRecordNumber ? (
          <>
            Copyright © 2025 瀚博半导体 All Rights Reserved |{' '}
            <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank" rel="noreferrer">
              沪ICP备19007197号-1 | 沪公网安备31011502019918号
            </a>
          </>
        ) : (
          platformConfig.recordNumber
        )}
      </div>
    </div>
  );
}
LoginPage.displayName = 'LoginPage';

export default LoginPage;
